import { render, staticRenderFns } from "./InsNav.vue?vue&type=template&id=1c73771c&scoped=true&"
import script from "./InsNav.vue?vue&type=script&lang=js&"
export * from "./InsNav.vue?vue&type=script&lang=js&"
import style0 from "./InsNav.vue?vue&type=style&index=0&id=1c73771c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c73771c",
  null
  
)

export default component.exports